
export default {
  name: 'HealthyWeightCalculator',
  data () {
    return {
      data: '',
      form: this.$vform({
        age: 25,
        gender: 'male',
        unit: 'metric',
        height_metric: 175,
        height_us_feet: 5,
        height_us_inch: 10
      })
    }
  },
  methods: {
    onHealthyWeightCalculator() {
        this.form.post(`/tool/healthy-weight-calculator`, { progress: false }).then(res => {
          this.data = Object.values(res.data);
        }).catch(e => {
          console.log(e);
        });
    }
  }
}
